import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Icon, Button, Modal, Header, Popup } from 'semantic-ui-react';
import { LoadingBar, InfiniteScroll } from 'components/Commons';

import ReactTable from 'react-table';
import Infinite from 'react-infinite';
import cm from 'helpers/commons';
import scroll from 'helpers/scroll';
import toastr from 'helpers/toastr';

const defaultProps = {
  list: null
};
class ExcelDeductList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: [],
      heightIdx: 0,
      containerHeight: 620,
      headers: [
        { header: '상태', width: 100, changeColor: true },
        { header: 'ID', width: 120 },
        { header: '이름', width: 120 },
        { header: '사원번호', width: 128 },
        { header: '권한', width: 103 },
        { header: '식대그룹', width: 128 },
        { header: '식대정책', width: 128 },
        { header: '식대 (원/장)', width: 103, changeColor: true },
        { header: '사유', width: 210 },
        { header: '실패사유', width: 800, changeColor: true }
      ]
    };
  }

  componentWillMount() {
    const { list } = this.props;
    this.scrollEvent(list);
  }

  componentWillReceiveProps(nextProps) {
    const { list } = nextProps;

    if (list && list.response) {
      toastr('top-right', 'error', list.response.data.message);
    } else {
      this.scrollEvent(list);
    }
  }

  componentDidMount() {}

  scrollEvent = (list) => {
    if (list && list.data) {
      const { user } = list.data;

      if (list && user.length > 0) {
        this.setState({
          elements: this.buildElements(0, 100, user, false)
        });
      } else {
        this.setState({ elements: [] });
      }
    }
  };

  handleInfiniteLoad = () => {
    const { list } = this.props;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = list && list.data ? list.data.user : null;

    const that = this;
    const elemLength = elements.length;
    const itemLength = item ? item.length : 0;
    const infiniteParm = scroll.event(item, elements, containerHeight, heightIdx, elemLength);

    if (elemLength < itemLength) {
      const data = this.buildElements(elemLength, elemLength + 100, list.data.user);

      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });

      setTimeout(() => {
        that.setState({
          elements: that.state.elements.concat(data),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      this.setState({
        isInfiniteLoading: false
      });
    }
  };

  listItem = (item, idx) => {
    const { headers } = this.state;
    let result = null;

    if (item) {
      let division = null;

      const styles = [];

      let amountText = '';
      let amountColor = 'black';
      if (item.task.amount >= 0) {
        amountText = cm.numberComma(item.task.amount);
      } else {
        amountText = cm.convertMinusNumber(item.task.amount);
        amountColor = '#e20b44';
      }

      let causeColor = '';

      if (item.status.value === 'fail') {
        causeColor = '#e20b44';
      }

      if (item.status.value === 'fail_auth') {
        division = cm.notErrorTrTdDivision(item.fulldivision[0]);
        causeColor = '#e20b44';
      } else {
        division = cm.trTdDivision(item.orgcode);
      }

      headers.forEach((headerItem, index) => {
        let color = null;

        if (index === 0 || index === 9) {
          color = causeColor;
        } else if (index === 7) {
          color = amountColor;
        }

        styles.push({
          flex: `${headerItem.width} 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 0',
          color
        });
      });

      result = (
        <div className="rt-tr -odd" key={idx}>
          <div className="rt-td" style={styles[0]}>
            {item.status.text}
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.signid}
          </div>
          <div className="rt-td" style={styles[2]}>
            {item.name}
          </div>
          {division.map((divi, i) => (
            <div
              key={`divi${i}`}
              className="rt-td"
              style={{ flex: '128 0 auto', width: 128, maxWidth: 128, padding: '10px 0' }}
            >
              <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
            </div>
          ))}
          <div className="rt-td" style={styles[3]}>
            {item.comidnum}
          </div>
          <div className="rt-td" style={styles[4]}>
            {item.grade && item.grade.text}
          </div>
          <div className="rt-td" style={styles[5]}>
            {item.group.name}
          </div>
          <div className="rt-td" style={styles[6]}>
            {item.policy.name}
          </div>
          <div className="rt-td" style={styles[7]}>
            {amountText}
          </div>
          <div className="rt-td" style={styles[8]}>
            {item.task.cause}
          </div>
          <div className="rt-td" style={styles[9]}>
            {item.status.cause}
          </div>
        </div>
      );
      return result;
    }
    return null;
  };

  buildElements = (start, end, item, isChecked) => {
    const elements = [];
    if (!item) {
      return elements;
    }

    for (let i = start; i < end; i++) {
      const temp = this.listItem(item[i], i);

      if (temp) {
        elements.push(temp);
      }
    }
    return elements;
  };

  elementInfiniteLoad = () => {
    const dom = document.getElementById('deduct-excel-dom');
    const height = dom ? dom.offsetHeight : null;
    return <LoadingBar style={{ height }} />;
  };

  tBodyFunc = (state) => {
    const { elements, containerHeight, isInfiniteLoading } = this.state;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          <Infinite
            className="infinite-scroll"
            elementHeight={30}
            containerHeight={containerHeight}
            infiniteLoadBeginEdgeOffset={containerHeight - 50}
            onInfiniteLoad={this.handleInfiniteLoad}
            loadingSpinnerDelegate={this.elementInfiniteLoad()}
            isInfiniteLoading={isInfiniteLoading}
            handleScroll={this.scrollHandler}
          >
            {elements}
          </Infinite>
        </div>
      </div>
    );
  };

  noDataProps = (state) => {
    const { list } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (list && list.data) {
      dom = <div className="rt-noData" />;
    }

    return dom;
  };

  render() {
    const { list, isUploadLoading } = this.props;
    const { elements, isInfiniteLoading, heightIdx, headers, containerHeight } = this.state;
    const listText = {
      text: '',
      style: {}
    };
    const header = cm.tableHeaderList(headers, 3, true);
    const columns = scroll.header(header, null);

    if (list && list.data) {
      const { count } = list.data;

      listText.text = `총 (${count.total}명) :  성공 (지급: ${count.plus}, 차감: ${count.minus} ) / 해당없음 (${count.none}) / 실패 (${count.fail}) / 실패 예정 (${count.pre_fail})`;

      listText.style = {
        fontWeight: 'bold',
        marginBottom: '16px'
      };
    }

    return isUploadLoading ? (
      <LoadingBar />
    ) : (
      <div>
        <Header as="h3" dividing>
          지급/차감 목록
        </Header>
        <div className="list-text" style={listText.style}>
          <span>{listText.text}</span>
        </div>
        <div className="deduct-list">
          <ReactTable
            className="react-table"
            noDataText="엑셀파일을 업로드해주세요."
            columns={columns}
            sortable={false}
            resizable={false}
            showPagination={false}
            loading={isInfiniteLoading}
            getLoadingProps={this.test}
            TbodyComponent={this.tBodyFunc}
            NoDataComponent={this.noDataProps}
          />
        </div>
      </div>
    );
  }
}

ExcelDeductList = connect((state) => ({}))(ExcelDeductList);

export default ExcelDeductList;
